import { render, staticRenderFns } from "./voteHall.vue?vue&type=template&id=1b5cf448&scoped=true"
import script from "./voteHall.vue?vue&type=script&lang=js"
export * from "./voteHall.vue?vue&type=script&lang=js"
import style0 from "./voteHall.vue?vue&type=style&index=0&id=1b5cf448&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5cf448",
  null
  
)

export default component.exports